import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgInspectieWoning = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M6.3 14.29 19.352 6l13.051 8.29V35H6.3z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m15.834 6.008 7.986 5.07-.537.844-7.449-4.73-8.741 5.55-.536-.844z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="m37.8 33.69-5.775-5.49a8.38 8.38 0 0 0 1.491-6.116c-.32-2.145-1.468-4.099-3.22-5.48-1.752-1.38-3.982-2.09-6.253-1.988s-4.422 1.007-6.03 2.539c-1.609 1.531-2.56 3.58-2.666 5.743-.107 2.163.638 4.287 2.088 5.956 1.45 1.668 3.501 2.762 5.753 3.066a9.5 9.5 0 0 0 6.422-1.42l5.764 5.5zm-18.175-5.77a6.44 6.44 0 0 1-1.879-3.343 6.24 6.24 0 0 1 .389-3.774 6.6 6.6 0 0 1 2.525-2.932 7.1 7.1 0 0 1 3.81-1.1c1.357 0 2.683.382 3.81 1.1a6.6 6.6 0 0 1 2.525 2.932 6.24 6.24 0 0 1 .39 3.774 6.44 6.44 0 0 1-1.879 3.343c-1.287 1.22-3.03 1.906-4.846 1.906s-3.558-.685-4.845-1.906"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M19.862 22.75a4.8 4.8 0 0 0 .4 1.932 5.05 5.05 0 0 0 1.151 1.644 5.4 5.4 0 0 0 1.734 1.105c.65.257 1.348.389 2.053.389v1c-.83 0-1.652-.156-2.42-.46a6.4 6.4 0 0 1-2.057-1.31 6.05 6.05 0 0 1-1.378-1.97 5.8 5.8 0 0 1-.483-2.33z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgInspectieWoning);

export default ForwardRef;
